import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Offering, QUESTION } from '@arrk-engineering-gmbh/shared';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { Select } from 'primeng/select';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
@Component({
  selector: 'lib-cms-card',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputText,
    Textarea,
    MultiSelectModule,
    Select,
    Button,
    Dialog,
    CdkDragHandle
  ],
  templateUrl: './cms-card.html',
  styleUrl: './cms-card.scss'
})
export class CmsCardComponent implements OnInit, OnChanges {
  @Input() service: Offering | null = null;
  @Input() labelOptions: string[] | null = null;
  @Input() singleLabel = false;
  @Output() deleteService = new EventEmitter<void>();
  @Output() serviceChange = new EventEmitter<Offering>();
  editTitle = '';
  editDescription = '';
  editLabels: string[] = [];
  currentImageSrc = '';
  uploadedFileName = '';
  uploadedFileSize = '';
  showDeleteDialog = false;
  get allLabelOptions(): { label: string; value: string }[] {
    const source = this.labelOptions ?? QUESTION.options;
    return source.map((opt) => ({ label: opt, value: opt }));
  }
  get singleLabelValue(): string | null {
    return this.editLabels[0] ?? null;
  }
  ngOnInit(): void {
    this.syncFromService();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['service']) {
      this.syncFromService();
    }
  }
  private syncFromService(): void {
    if (this.service) {
      this.editTitle = this.service.title;
      this.editDescription = this.service.description;
      this.editLabels = [...this.service.labels];
      const img = this.service.image ?? '';
      if (!img) {
        this.currentImageSrc = '';
        this.uploadedFileName = '';
      } else if (img.startsWith('data:')) {
        this.currentImageSrc = img;
        this.uploadedFileName = 'Uploaded file';
      } else {
        this.currentImageSrc = (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('/')) ? img : '/' + img;
        this.uploadedFileName = '';
      }
      this.uploadedFileSize = '';
    }
  }
  private emitChange(): void {
    this.serviceChange.emit({
      title: this.editTitle,
      description: this.editDescription,
      image: this.currentImageSrc,
      labels: [...this.editLabels]
    });
  }
  onTitleChange(val: string): void {
    this.editTitle = val;
    this.emitChange();
  }
  onDescriptionChange(val: string): void {
    this.editDescription = val;
    this.emitChange();
  }
  onLabelsChange(val: string[]): void {
    this.editLabels = val ?? [];
    this.emitChange();
  }
  onSingleLabelChange(val: string | null): void {
    this.editLabels = val ? [val] : [];
    this.emitChange();
  }
  onNativeFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.uploadedFileName = file.name;
      this.uploadedFileSize = this.formatFileSize(file.size);
      const reader = new FileReader();
      reader.onload = (e) => {
        this.currentImageSrc = e.target?.result as string;
        this.emitChange();
      };
      reader.readAsDataURL(file);

      input.value = '';
    }
  }
  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }
  onDeleteClick(): void {
    this.showDeleteDialog = true;
  }
  onConfirmDelete(): void {
    this.showDeleteDialog = false;
    this.deleteService.emit();
  }
  onCancelDelete(): void {
    this.showDeleteDialog = false;
  }
}
